"use strict";

exports.__esModule = true;
exports.RcDialog = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactHooks = require("@okee-uikit/react-hooks");

var _animation = require("../../hooks/animation");

var _mask = require("../../hooks/mask");

var _portal = require("../../hooks/portal");

var _layer = require("../../context/layer");

var _useLayer = require("../../hooks/useLayer");

var _excluded = ["toBody", "contentRef", "getContainer", "wrapperRef", "wrapperClassName", "wrapperStyle", "mask", "maskClassName", "maskStyle", "onMaskClick", "style", "zIndex", "animation", "children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function RcDialogFC(props) {
  var _props$toBody = props.toBody,
      toBody = _props$toBody === void 0 ? false : _props$toBody,
      contentRef = props.contentRef,
      getContainer = props.getContainer,
      _props$wrapperRef = props.wrapperRef,
      wrapperRef = _props$wrapperRef === void 0 ? null : _props$wrapperRef,
      wrapperClassName = props.wrapperClassName,
      wrapperStyle = props.wrapperStyle,
      mask = props.mask,
      maskClassName = props.maskClassName,
      _props$maskStyle = props.maskStyle,
      maskStyle = _props$maskStyle === void 0 ? {} : _props$maskStyle,
      onMaskClick = props.onMaskClick,
      style = props.style,
      zIndex = props.zIndex,
      _props$animation = props.animation,
      animation = _props$animation === void 0 ? {
    disabled: true
  } : _props$animation,
      children = props.children,
      restProps = _objectWithoutPropertiesLoose(props, _excluded);

  var getContainerGetter = (0, _reactHooks.useRefGetter)(getContainer);
  var getLayer = (0, _useLayer.useLayer)(toBody);
  var wrapperRefObject = (0, _react.useRef)(null);
  var innerWrapperRef = (0, _reactHooks.useCombineRef)(wrapperRef, wrapperRefObject);
  var contentRefObject = (0, _react.useRef)(null);
  var innerContentRef = (0, _reactHooks.useCombineRef)(contentRef, contentRefObject);
  var wrapperZIndex = (0, _react.useMemo)(function () {
    return zIndex !== null && zIndex !== void 0 ? zIndex : (0, _reactHooks.getZIndex)();
  }, [zIndex]);
  var handleGetContainer = (0, _react.useCallback)(function () {
    var getter = getContainerGetter();

    if (getter) {
      return getter();
    }

    return getLayer();
  }, []);
  (0, _animation.useCSSEnterLeave)(wrapperRefObject, animation);
  var onClickCallback = (0, _react.useCallback)(function (e) {
    if (innerContentRef.current === e.target) {
      onMaskClick && onMaskClick(e);
    }
  }, [onMaskClick]);

  if (typeof window === 'undefined') {
    return null;
  }

  return _react.default.createElement(_portal.RcPortal, {
    getContainer: handleGetContainer
  }, _react.default.createElement("div", {
    ref: innerWrapperRef,
    className: wrapperClassName,
    style: _extends({
      zIndex: wrapperZIndex
    }, wrapperStyle),
    onClick: onClickCallback
  }, mask && _react.default.createElement(_mask.RcMask, {
    show: true,
    className: maskClassName,
    defaultStyle: false,
    style: maskStyle
  }), _react.default.createElement(_layer.LayerContext.Provider, {
    value: innerContentRef
  }, _react.default.createElement("div", _extends({}, restProps, {
    ref: innerContentRef,
    style: _extends({}, style),
    tabIndex: 0
  }), children))));
}

var RcDialog = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(RcDialogFC, _extends({}, props, {
    wrapperRef: ref
  }));
});

exports.RcDialog = RcDialog;